import Vue from 'vue'
import axios from 'axios'
import helpers from '../../helpers'

Vue.use(axios)

const state = {
  settings: {},
  offerProgrammes: [],
  offers: [],
  genderOptions: ['male', 'female', 'other']
}

const getters = {
  getSettings: state => state.settings,
  getOfferProgrammes: state => state.offerProgrammes,
  getOffers: state => state.offers,
  getGenderOptions: state => state.genderOptions
}

const actions = {
  // fetch system setting information
  async fetchSettings ({ commit }, callback) {
    commit('clearLastError')
    if (process.env.VUE_APP_API_PATH) {
      try {
        const resp = await axios.get(
          process.env.VUE_APP_API_PATH + 'ajax/options/setting'
        )

        if (resp && resp.data) {
          commit('setSettings', resp.data.dataSet)
        }

        if (helpers.isFunction(callback)) {
          callback()
        }
      } catch (error) {
        commit('setLastError', 'Error while loading data')
        console.log(error)
      }
    }
  },

  // fetch active offer types
  async fetchOfferProgrammes ({ commit }) {
    commit('clearLastError')
    if (process.env.VUE_APP_API_PATH) {
      try {
        const resp = await axios.get(
          process.env.VUE_APP_API_PATH + 'ajax/options/offer_programmes'
        )

        if (resp && resp.data && resp.data.dataSet) {
          commit('updateOfferProgrammes', resp.data.dataSet.records)
        }
      } catch (error) {
        commit('setLastError', 'Error while loading data')
        console.log(error)
      }
    }
  },

  // fetch active offers
  async fetchOffers ({ commit }) {
    commit('clearLastError')
    if (process.env.VUE_APP_API_PATH) {
      try {
        const resp = await axios.get(
          process.env.VUE_APP_API_PATH + 'ajax/options/offers'
        )

        if (resp && resp.data && resp.data.dataSet) {
          commit('updateOffers', resp.data.dataSet.records)
        }
      } catch (error) {
        commit('setLastError', 'Error while loading data')
        console.log(error)
      }
    }
  }
}

const mutations = {
  setSettings: (state, payload) => (state.settings = payload),
  updateOffers: (state, payload) => (state.offers = payload),
  updateOfferProgrammes: (state, payload) => (state.offerProgrammes = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
